// import axios from "axios";
// import { POST_GENERATE_CAT_PAPER } from "../../../utils/api";

// export const generateCatTest = (payLoad) => async (dispatch) => {
//   const token = localStorage.getItem("access_token");

//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "application/json",
//   };

//   try {
//     const resp = await axios.post(POST_GENERATE_CAT_PAPER,
//       payLoad,
//       {
//         headers,
//         withCredentials: true,
//       }
//     );

//     // dispatch({
//     //   type: GENERATE_ASSIGNMENT_QUESTIONS_SUCCESS,
//     //   payload: resp.data,
//     // });

//     return { success: true, data: resp.data };

//   } catch (error) {
//     console.error("Unable to process request.", error);

//     const errorMessage =
//       error?.response?.data?.detail ||
//       error?.response?.data?.message ||
//       error.message ||
//       "Something went wrong";

//     // dispatch({
//     //   type: GENERATE_ASSIGNMENT_QUESTIONS_FAILURE,
//     //   payload: {
//     //     message: errorMessage,
//     //   },
//     // });

//     return { success: false, message: errorMessage };
//   }
// };

// export const finalizeCatTest = (payLoad) => async (dispatch) => {
//   const token = localStorage.getItem("access_token");

//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "application/json",
//   };

//   try {
//     const resp = await axios.post(POST_GENERATE_CAT_PAPER,
//       payLoad,
//       {
//         headers,
//         withCredentials: true,
//       }
//     );

//     // dispatch({
//     //   type: GENERATE_ASSIGNMENT_QUESTIONS_SUCCESS,
//     //   payload: resp.data,
//     // });

//     return { success: true, data: resp.data };

//   } catch (error) {
//     console.error("Unable to process request.", error);

//     const errorMessage =
//       error?.response?.data?.detail ||
//       error?.response?.data?.message ||
//       error.message ||
//       "Something went wrong";

//     // dispatch({
//     //   type: GENERATE_ASSIGNMENT_QUESTIONS_FAILURE,
//     //   payload: {
//     //     message: errorMessage,
//     //   },
//     // });

//     return { success: false, message: errorMessage };
//   }
// };


import { apiRequest } from "../../../api/apiRequest";
import { POST_GENERATE_CAT_PAPER } from "../../../utils/api";

export const generateCatTest = (payLoad) => async (dispatch) => {
  const result = await apiRequest("post", POST_GENERATE_CAT_PAPER, payLoad);

  if (result.success) {
    // dispatch({
    //   type: GENERATE_ASSIGNMENT_QUESTIONS_SUCCESS,
    //   payload: result.data,
    // });
    return { success: true, data: result.data };
  }

  console.error("Unable to process request.", result.message);

  // dispatch({
  //   type: GENERATE_ASSIGNMENT_QUESTIONS_FAILURE,
  //   payload: {
  //     message: result.message,
  //   },
  // });

  return { success: false, message: result.message };
};

export const finalizeCatTest = (payLoad) => async (dispatch) => {
  const result = await apiRequest("post", POST_GENERATE_CAT_PAPER, payLoad);

  if (result.success) {
    // dispatch({
    //   type: GENERATE_ASSIGNMENT_QUESTIONS_SUCCESS,
    //   payload: result.data,
    // });
    return { success: true, data: result.data };
  }

  console.error("Unable to process request.", result.message);

  // dispatch({
  //   type: GENERATE_ASSIGNMENT_QUESTIONS_FAILURE,
  //   payload: {
  //     message: result.message,
  //   },
  // });

  return { success: false, message: result.message };
};